import axios from 'axios'
import configApp from '@/config'
import Vue from 'vue'

/*
 | Si la academia ve lo de IA, segun lo que diga el backend y no lo que habia al compilar.
 |
 | El problema que resuelve: droopInteligenciaArtificialHabilitado vive en el config, asi que apagar
 | la venta de IA —porque salio cara, porque el proveedor se cayo— pedia editar el archivo y volver a
 | compilar. Ahora se apaga desde los Ajustes de IA de app-sales y la proxima carga ya no la muestra.
 |
 | El valor arranca de lo ultimo que contesto el backend, guardado en el navegador, o del config si
 | nunca contesto; al instalar el plugin se vuelve a preguntar y lo que haya en pantalla se redibuja
 | solo, porque esto es una instancia de Vue y las pantallas lo leen en un computed. O sea que se ve
 | siempre la ultima respuesta conocida, y en el peor caso un parpadeo, no un despliegue.
 |
 | Lo que se guarda no es informacion de nadie: es el mismo interruptor que cualquiera deduce mirando
 | la pantalla.
 */

const CLAVE_GUARDADA = 'vidroop:visibilidad-ia'

/** Lo ultimo que contesto el backend, o null si no hay nada legible. */
function loGuardado () {
  try {
    const crudo = localStorage.getItem(CLAVE_GUARDADA)
    return crudo === null ? null : JSON.parse(crudo) === true
  } catch (error) {
    // Sin acceso al almacenamiento o con algo ilegible: vale el del config
    return null
  }
}

let visibilidadIa = new Vue({
  data () {
    const guardado = loGuardado()

    return {
      visible: guardado === null
        ? configApp.droopInteligenciaArtificialHabilitado === true
        : guardado
    }
  },

  methods: {
    /*
     | Pregunta al backend y actualiza. Si falla no cambia nada: se sigue con lo ultimo conocido. Que
     | el backend no conteste no es motivo para esconder una funcion que se esta usando, ni para
     | mostrar una que esta apagada.
     |
     | El endpoint es publico (no pide sesion) justamente para esto: se puede preguntar al arrancar,
     | antes de que haya alguien logueado.
     */
    refrescar () {
      return axios
        .get(`${configApp.apiUrl}/${configApp.apiVersion}/satelites/ia/visibilidad`)
        .then(({ data }) => {
          this.visible = data.academy === true

          try {
            localStorage.setItem(CLAVE_GUARDADA, JSON.stringify(this.visible))
          } catch (error) {
            // Sin almacenamiento el valor vale igual, solo que no sobrevive a la recarga
          }
        })
        .catch(() => {})
    }
  }
})

export default {
  install: (Vue) => {
    Vue.prototype.$iaVisible = visibilidadIa
    // Una sola vez por carga: es la misma respuesta para toda la aplicacion
    visibilidadIa.refrescar()
  }
}
